import { createFormConfigRegistry } from '@risksmart-app/shared/forms/formConfigRegistry';
import { useMemo } from 'react';
import { useModulesStore } from 'src/context/moduleContext';
import { useFeatures } from 'src/rbac/useFeatures';

/**
 * Returns the whole form config registry
 * @returns
 */
export const useFormConfigRegistry = () => {
  const enabledFeatures = useFeatures();
  const modules = useModulesStore((s) => s.modules);

  return useMemo(
    () => createFormConfigRegistry(enabledFeatures, modules),
    [enabledFeatures, modules]
  );
};
